import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface CampaignConfig {
  id: string;
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  themeGradient: string;
  themeColor: string;
  targetCountries: string[];
  bannerBadgeText: string;
  hero?: {
    titleHtml: string;
    leadTextHtml: string;
    featuredVideoUrl?: string;
    featuredVideoTitle?: string;
    notes: { textHtml: string; colorClass: string }[];
  };
  videos?: {
    id: string;
    title: string;
    description: string;
    videoUrl: string;
    personaKey?: string;
    tag?: string;
    thumbnail?: string;
  }[];
  personas?: any[];
  faqs?: { q: string; a: string; open?: boolean }[];
  resources: any[]; // Static resources for now
}

@Injectable({
  providedIn: 'root'
})
export class CampaignService {

  constructor(private http: HttpClient) { }

  // Simulate an API call that returns campaigns active for a specific country
  getActiveCampaigns(countryName: string): Observable<CampaignConfig[]> {
    if (!countryName) return of([]);
    // For now, load our mock JSON and wrap it in an array so the homepage banner renders
    return this.http.get<CampaignConfig>(`assets/mock-data/campaign-i-am.json`).pipe(
      map(campaign => {
        // Only return this campaign if the user's country is in its target list
        if (campaign.targetCountries && campaign.targetCountries.includes(countryName)) {
          return [campaign];
        }
        return [];
      }),
      catchError(err => {
        console.error('Error loading active campaigns', err);
        return of([]);
      })
    );
  }

  // Simulate an API call to get details for a specific campaign by slug
  getCampaignBySlug(slug: string): Observable<CampaignConfig | undefined> {
    // In a real scenario, this hits the backend API `/api/campaigns/${slug}`
    // For now, we load from our local mock JSON acting as the REST API.
    return this.http.get<CampaignConfig>(`assets/mock-data/campaign-${slug}.json`).pipe(
      catchError(err => {
        console.error(`Error loading campaign mock data for ${slug}`, err);
        return of(undefined);
      })
    );
  }
}
